<template>
    <div class="content">
        <div class="title font32 bold left">区域图片上传</div>
        <div class="uploadlist flex-def flex-zLeftRight flex-zCenter flex-wrap">
            <div v-for="(item,index) in imgs" :key="index" class="uploaditem flex-def flex-zTopBottom flex-zCenter">
                <van-uploader v-model="item.img" image-fit="contain" :max-count="1" :before-read="beforeRead"
                    :after-read="(file,detail)=>{afterRead(file,detail,index)}" />
                <p class="font24">{{item.title}}</p>
            </div>
        </div>
        <div class="title flex-def flex-zBetween">
            <p class="font32 bold left">员工温度上传℃</p>
            <p class="font24 bold brown">{{dateTime}}</p>
        </div>
        <div class="stafflist">
            <div class="staffitem flex-def flex-zBetween" v-for="(item,index) in staffList" :key="index">
                <div class="flex-def flex-cCenter">
                    <p class="post White font22">{{item.postName}}</p>
                    <p class="name font28">{{item.employeeName}}</p>
                </div>
                <van-stepper v-model.number="item.temperature" theme="round" button-size="22" step="0.1" max="39" min="35" />
            </div>
        </div>
        <van-button class="submit White font32 bold" @click="submit">上传 并 生成海报</van-button>
        <van-overlay :show="show">
            <div class="wrapper" @click.stop>
                <div class="painter">
                    <vue-canvas-poster :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
                    <img class="img" ref="img" :src="posterImg" alt="">
                    <van-icon class="close" name="close" @click="show=false;init()" />
                    <!-- <a class="download"  download="xiaosha.png" :href="posterImg">保存海报至相册</a> -->
                </div>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import Vue from 'vue'
import request from "@/utils/request";
import axios from 'axios';

import OSS from 'ali-oss';
import { timeToTime, timeToDate2 } from "../../../utils/util.js";
import { getCookie } from '@/utils/index'

import { Image, Button, Popup, Toast, Dialog, Uploader, Stepper, Overlay, Icon } from 'vant';
Vue.use(Image).use(Button).use(Popup).use(Toast).use(Dialog).use(Uploader).use(Stepper).use(Overlay).use(Icon);
export default {
    name: "disinfect",

    data() {
        return {
            imgs: [],
            staffList: [],
            dateTime: '',
            storeData: {},
            painting: {
                width: '750px',
                height: '1400px',
                views: []
            },
            posterImg: '',
            show: false,
            client: null,
            domain: ''
        }
    },
    mounted() {
        this.setOSS();
        this.init();
        this.onLoad()
    },
    methods: {
        onLoad() {
            const storeId = getCookie('storeId') || localStorage.getItem('storeId');
            const storeNo = this.$route.query.storeNo
            request({
                url: `/xiaosha/info?storeId=${storeId}&storeNo=${storeNo}`,
                method: "get",
            })
                .then((res) => {
                    this.staffList = res.data.data;
                    this.imgs = res.data.imgData;
                    this.storeData = res.data.storeData;
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' });
                })
        },
        setOSS() {
            request({
                url: `/aliyun/token`,
                method: "get",
            })
                .then((res) => {
                    // 配置oss
                    this.client = new OSS({
                        region: res.data.region,
                        //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，创建并使用STS方式来进行API访问
                        accessKeyId: res.data.accessKeyId,
                        accessKeySecret: res.data.accessKeySecret,
                        stsToken: res.data.securityToken,
                        bucket: res.data.bucket
                    });
                    this.domain = res.data.domain
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' });
                })
            // ossToken().then(res=>{
            //     if(res.s > 0){
            //         // 配置oss
            //         this.client = new OSS({
            //             region: res.d.data.region,
            //             //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，创建并使用STS方式来进行API访问
            //             accessKeyId: res.d.data.accessKeyId,
            //             accessKeySecret: res.d.data.accessKeySecret,
            //             stsToken: res.d.data.securityToken,
            //             bucket: res.d.data.bucket
            //         });
            //         this.domain = res.d.data.domain
            //     }else{
            //         Toast.fail({message:res.err_str,duration:1000});
            //     }
            // })
        },
        init() {

            // let img = window.SITE_CONFIG['apiURL'] + 'active/qrcode?store_no=' + this.$route.query.orgcode + "&token=" + checkToken();
            let img = 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/QRCode.jpg'
            this.painting.views = [
                {
                    type: 'image',
                    url: require('../../../assets/img/ad.png'),
                    css: {
                        top: '0px',
                        left: '0px',
                        width: '750px',
                        height: '1400px'
                    }
                },
                {
                    type: 'text',
                    text: '已消毒空间',
                    css: {
                        fontSize: '32px',
                        top: '314px',
                        color: '#BC8F79',
                        textAlign: 'center',
                        width: '750px'
                    }
                },
                {
                    type: 'text',
                    text: '美丽田园全体员工静待您的光临！',
                    css: {
                        fontSize: '24px',
                        top: '1110px',
                        color: '#35434c',
                        width: '750px',
                        textAlign: 'center',
                        fontWeight: 'bold'
                    }
                },
                {
                    type: 'image',
                    url: img,
                    css: {
                        top: '1237px',
                        left: '580px',
                        width: '130px',
                        height: '130px'
                    }
                },
            ]
        },

        beforeRead(file, detail) {

            const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
            const type = 'banner';
            if (!isJPG) {
                Toast('请上传图片!');
                return false;
            }
            return true;
        },
        afterRead(file, detail, index) {
            let that = this;
            // 配置名字
            let files = file.file;
            const point = files.name.lastIndexOf('.')
            let suffix = files.name.substr(point)
            let fileName = files.name.substr(0, point)
            let dateName = files.lastModified;
            let fileNames = `${fileName}${dateName}${suffix}`
            // 分片上传文件
            let datefile = timeToDate2();
            var ret = that.client.multipartUpload("/xiaosha/" + datefile + "/" + fileNames, files, {
                progress: async function (p) {
                    if (p == 1) {
                        Toast.clear();
                        Toast('图片上传成功!');
                        that.imgs[index].img[0].url = that.domain + "/xiaosha/" + datefile + "/" + fileNames;

                    }
                }
            })
        },
        success(src) {
            this.posterImg = src;
        },
        fail(err) {
            Dialog.alert({
                title: '提示',
                message: err
            })
        },
        submit() {
            var canLoad = true;
            this.imgs.forEach(el => {
                if (el.img.length == 0) {
                    canLoad = false;
                }
            });
            if (!canLoad) {
                Toast.fail('请上传6张图片再提交！');
                return false;
            }

            // 标题
            this.painting.views.push(
                {
                    type: 'text',
                    text: this.storeData.storeName,
                    css: {
                        fontSize: '28px',
                        top: '265px',
                        color: '#323232',
                        textAlign: 'center',
                        width: '750px',
                    }
                }
            )
            //内容
            this.painting.views.push(
                {
                    type: 'text',
                    text: '更新于' + timeToTime(),
                    css: {
                        fontSize: '30px',
                        top: '368px',
                        color: '#BC8F79',
                        textAlign: 'center',
                        width: '750px'
                    }
                }
            )
            // 图片
            this.imgs.forEach((item, index) => {
                if (index <= 2) {
                    this.painting.views.push(
                        {
                            type: 'image',
                            url: item.img[0].url + '?x-oss-process=image/resize,h_210,w_315/auto-orient,1',
                            css: {
                                top: '432px',
                                left: 50 + index * 220 + 'px',
                                width: '210px',
                                height: '315px',
                                borderRadius: '8px'
                            }
                        }
                    )
                } else {
                    this.painting.views.push(
                        {
                            type: 'image',
                            url: item.img[0].url + '?x-oss-process=image/resize,h_210,w_315/auto-orient,1',
                            css: {
                                top: '757px',
                                left: 50 + (index - 3) * 220 + 'px',
                                width: '210px',
                                height: '315px',
                                borderRadius: '8px'
                            }
                        }
                    )
                }
            });
            let image_data = [];
            this.imgs.forEach(el => {
                image_data.push(
                    {
                        img: el.img[0].url,
                        title: el.title
                    }
                )
            });
            let info = {
                storeData: this.storeData,
                imgData: image_data,
                data: this.staffList
            }
            request({
                url: `/xiaosha`,
                method: "post",
                data: info
            })
                .then((res) => {
                    this.show = true;

                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' });
                }).finally(() => {

                });
        },
    }
}
</script>
<style lang="less">
@import ".././../../assets/css/style.less";
</style>
<style scoped lang="less">
.brown {
    color: #c09681;
}
.border {
    border-bottom: 1px solid #e6e6e6;
}
.content {
    position: relative;
    padding-bottom: 174px;
    height: 100%;
    overflow-y: auto;
    .title {
        height: 112px;
        line-height: 112px;
        padding: 0 30px;
    }
    .uploadlist {
        .uploaditem {
            width: 182px;
            margin: 0 20px 30px;
            p {
                margin-top: 24px;
            }
        }
    }
    .stafflist {
        padding: 0 40px;

        .staffitem {
            border-bottom: 1px solid #e6e6e6;
            height: 112px;
            line-height: 112px;
            .post {
                background: rgba(214, 178, 86, 1);
                border-radius: 4px;
                height: 30px;
                line-height: 30px;
                padding: 0 4px;
            }
            .name {
                color: #656565;
                padding-left: 12px;
            }
        }
    }
    .submit {
        width: 630px;
        height: 88px;
        line-height: 88px;
        background: rgba(192, 150, 129, 1);
        border-radius: 44px;
        letter-spacing: 1px;
        position: fixed;
        bottom: 50px;
        left: 60px;
    }
    .painter,
    .img {
        width: 540px;
        height: 1008px;
    }
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }
    .painter {
        position: relative;
        .img {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10000;
        }
        .canvas {
            z-index: 20;
        }
        .close {
            position: absolute;
            top: -50px;
            right: -50px;
            color: #e6e6e6;
            font-size: 50px;
        }
        .download {
            position: absolute;
            bottom: -120px;
            left: 0;
            width: 540px;
            height: 81.5px;
            background: #c09681;
            border-radius: 44px;
            color: #ffffff;
            line-height: 81.5px;
            letter-spacing: 1px;
            font-weight: bold;
            font-size: 32px;
            padding: 0;
            margin: 0;
            border: none;
        }
    }
}
:deep .van-uploader__upload,
:deep .van-uploader__preview {
    width: 182px;
    height: 182px;
    margin: 0;
    .van-uploader__upload-icon {
        font-size: 50px;
    }
}
:deep .van-uploader__preview-image {
    width: 182px;
    height: 182px;
}
:deep .van-stepper--round .van-stepper__minus {
    color: #c09681;
    border-color: #c09681;
    margin-right: 36px;
}
:deep .van-stepper--round .van-stepper__plus {
    background-color: #c09681;
    margin-left: 36px;
}
:deep .van-stepper__input {
    font-size: 32px;
    font-weight: bold;
    width: 100px;
    color: #35434c;
}
:deep .van-stepper__minus::before,
:deep .van-stepper__plus::before {
    height: 4px;
}
:deep .van-stepper__minus::after,
:deep .van-stepper__plus::after {
    width: 4px;
}
:deep .van-uploader__preview-delete {
    width: 25px;
    height: 25px;
    border-radius: 0, 0, 0, 15px;
    background: rgba(0, 0, 0, 0.5);
}
:deep .van-uploader__preview-delete-icon {
    font-size: 30px;
    top: -2px;
    right: -2px;
    font-weight: bold;
}
:deep .van-uploader__preview-delete {
    border-radius: 0 0 0 30%;
}
:deep .van-uploader__preview-delete-icon {
    font-size: 36px;
    top: -3px;
    right: -5px;
}
</style>

